import React from "react";
import SelectionCard from "./SelectionCard";
import InserCartridge from "../../packs/images/insert-cartridge.png";

const InsertCartridge: React.FC = () => {
  return <SelectionCard heading="Insert sensor cartridge" info="Ensure that the appropriate cartridge has been correctly inserted into the device." image={InserCartridge} />;
};

export default InsertCartridge;
